import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import CardHeader from "@mui/material/CardHeader";
import CardMedia from "@mui/material/CardMedia";
import Typography from "@mui/material/Typography";

function ImageCard({ admisions, img, title, description, click, width }) {
  return (
    <Card sx={{ height: "100%", margin: 2 }}>
      <CardMedia
        component="div"
        image={img}
        sx={{
          borderRadius: 2,
          position: "relative",
          height: 0,
          paddingTop: "56.25%",
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
          "&:before": {
            content: '""',
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            bgcolor: "rgba(0,0,0,0.5)",
            zIndex: 1,
          },
        }}
      >
        <Box
          sx={{
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 2,
          }}
        >
          <img
            width={width || "50%"}
            src={img}
            alt={title}
            style={{
              borderRadius: 8,
              boxShadow: "0 4px 16px rgba(0,0,0,0.2)",
            }}
          />
        </Box>
      </CardMedia>
      {title && (
        <CardHeader
          title={
            <>
              <Typography variant="h5" align="center">
                <strong>{title}</strong>
              </Typography>
              <Typography variant="subtitle1" align="center">
                Inicio de actividades: <strong>{admisions}</strong>
              </Typography>
            </>
          }
        />
      )}
      {description && click && (
        <CardContent>
          <Typography variant="body2" color="text.secondary" align="justify">
            {description}
          </Typography>
          {click && (
            <Box sx={{ display: "flex", justifyContent: "center", mt: 2 }}>
              <Button
                variant="contained"
                color="success"
                sx={{
                  borderRadius: "20px",
                  px: 3,
                  fontWeight: "bold",
                  fontSize: "1rem",
                }}
                onClick={click}
              >
                Más información
              </Button>
            </Box>
          )}
        </CardContent>
      )}
    </Card>
  );
}

export default ImageCard;
